import { api } from '../../lib/apiClient';
import { uploadDirect } from '../../lib/directUpload';
import { useAuthStore } from '../../store/authStore';

export const fileRequestKeys = {
  list: (params) => ['file-requests', params ?? {}],
  meta: (token) => ['file-request-meta', token],
  submissions: (id) => ['file-request-submissions', id],
};

function ws() {
  const workspaceId = useAuthStore.getState().workspaceId;
  if (!workspaceId) throw new Error('No active workspace selected');
  return `/workspaces/${workspaceId}`;
}

/** Public upload link recipients open. */
export function requestLink(token) {
  return `${window.location.origin}/r/${token}`;
}

// ---- Owner side (authed) ----

export async function createFileRequest(payload) {
  const { data } = await api.post(`${ws()}/file-requests`, payload);
  return data; // { token, id, title, ... }
}

export async function listFileRequests(params = {}) {
  const { data } = await api.get(`${ws()}/file-requests`, { params });
  return data;
}

export const closeFileRequest = (id) => api.delete(`${ws()}/file-requests/${id}`);

export async function getFileRequestSubmissions(id, params = {}) {
  const { data } = await api.get(`${ws()}/file-requests/${id}/submissions`, { params });
  return data;
}

// ---- Public (recipient) ----

export async function resolveFileRequest(token) {
  const { data } = await api.get(`/file-requests/public/${token}`, { skipAuth: true });
  return data; // { title, instructions, requiresPassword, expiresAt, maxFiles, maxFileSizeBytes, allowedTypes, submissionCount }
}

export async function verifyFileRequestPassword(token, password) {
  const { data } = await api.post(
    `/file-requests/public/${token}/verify`,
    password ? { password } : {},
    { skipAuth: true },
  );
  return data;
}

/** Public upload browser → S3; every request rule is checked before bytes move. */
export function uploadToFileRequest(
  token,
  { file, uploaderName, uploaderEmail, password, onProgress, signal },
) {
  return uploadDirect({
    file,
    onProgress,
    signal,
    skipAuth: true,
    begin: async () => {
      const { data } = await api.post(
        `/file-requests/public/${token}/uploads`,
        {
          name: file.name,
          size: file.size,
          mimeType: file.type || undefined,
          uploaderName,
          uploaderEmail: uploaderEmail || undefined,
          password: password || undefined,
        },
        { skipAuth: true },
      );
      return data;
    },
  }); // → { ok: true, fileName }
}
